/* eslint-disable  @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useRef, useState } from 'react';

interface timer {
  timer: number;
  startTimer: () => void;
  resetTimer: () => void;
}

export const useTimer = (initialSeconds: number): timer => {
  const [timer, setTimer] = useState(initialSeconds);
  const timerRef: any = useRef(null);
  const requestRef: any = useRef(null);

  const updateTimer = () => {
    const now = Date.now();
    const elapsed = now - timerRef.current;
    if (elapsed >= 1000) {
      setTimer((t) => t - Math.floor(elapsed / 1000));
      timerRef.current = now;
    }
    requestRef.current = requestAnimationFrame(updateTimer);
  };

  const startTimer = useCallback(() => {
    timerRef.current = Date.now();
    requestRef.current = requestAnimationFrame(updateTimer);
  }, []);

  const resetTimer = () => {
    setTimer(initialSeconds);
    startTimer();
  };

  useEffect(() => {
    if (timer < 1) {
      cancelAnimationFrame(requestRef.current);
      setTimer(0);
    }
  }, [timer]);

  useEffect(() => {
    return () => {
      cancelAnimationFrame(requestRef.current);
    };
  }, []);

  return { timer, startTimer, resetTimer };
};
